import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import store from "./store/store";
import Vuebar from "vuebar";

import VuePaycard from "vue-paycard";
Vue.use(VuePaycard);

import { library } from '@fortawesome/fontawesome-svg-core'

import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(fas, fab, far)
Vue.component('font-awesome-icon', FontAwesomeIcon)

import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";

import "./plugins/base";
import "./plugins/components";

import axios from 'axios'
axios.defaults.timeout === 3000;
if (store.state.user && store.state.user.token) axios.defaults.headers.common['Authorization'] = `Bearer ${store.state.user.token}`

import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
Vue.use(Toast, {
  transition: "Vue-Toastification__bounce",
  maxToasts: 5,
  position: "top-right",
  timeout: 5000,
  newestOnTop: true,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: true,
  hideProgressBar: true,
  closeButton: "button",
  icon: true,
  rtl: false,
});

import { VueMaskDirective } from 'v-mask'
Vue.directive('mask', VueMaskDirective)

import VueSkycons from "vue-skycons";
Vue.use(VueSkycons, {
  color: "#1e88e5",
});

Vue.config.productionTip = false;
Vue.use(Vuebar);

Sentry.init({
  Vue,
  dsn: "https://20a988f42107487cba8d642f1383ee67@o1263829.ingest.sentry.io/6444240",
  integrations: [
    new BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: ["vamoscomemorar.com.br", /^\//],
    }),
  ],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

new Vue({
  vuetify,
  store,
  router,
  render: (h) => h(App),
}).$mount("#app");
